module.exports = __webpack_public_path__ + "static/media/shell.8512bfcb.png";